import React from "react";
import {
    Box,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Paper,
} from "@mui/material";
import { HistoricoEvento } from "../../../../../../../types/api/estoque/detalhar-ordem-compra";

export default function DialogHistoricoProduto({
    open,
    onClose,
    numeroOC,
    produto,
    valorTotal,
    entregue,
    quantidade,
    eventos,
}: HistoricoProdutoProps) {
    return (
        <Dialog open={open} maxWidth="xs" fullWidth onClose={onClose}>
            <DialogTitle sx={{ p: 0 }}>
                <Box sx={{
                    bgcolor: "#f5f5f5",
                    px: 0,
                    pt: 3,
                    pb: 2,
                    borderRadius: "8px 8px 0 0",
                    textAlign: "center"
                }}>
                    <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>Histórico de produto</Typography>
                    <Typography sx={{ fontWeight: "bold", fontSize: "1.08rem", mb: 0.5 }}>{`OC ${numeroOC}`}</Typography>
                    <Typography sx={{ mb: 0.5 }}>{produto}</Typography>
                    <Typography sx={{ fontWeight: "bold", fontSize: "1.1rem", mb: 0.5 }}>
                        Valor total do pedido <span style={{ fontWeight: 700 }}>R$ {valorTotal.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</span>
                    </Typography>
                    <Typography sx={{ color: "#F7B92B", fontWeight: "bold", mb: 0 }}>
                        Entregue {entregue}/{quantidade}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ px: 0, pt: 0 }}>
                <Paper elevation={0} sx={{ bgcolor: "#f5f5f5", px: 0 }}>
                    <Box sx={{ bgcolor: "#fff", px: 3, pt: 2, pb: 2 }}>
                        {eventos && eventos.length > 0 ? eventos.map((ev, idx) => (
                            <Box key={idx} display="flex" alignItems="flex-start" sx={{ mb: 1.5 }}>
                                <Box sx={{
                                    mr: 2,
                                    mt: 0.5,
                                    minWidth: 18,
                                    display: "flex",
                                    justifyContent: "center"
                                }}>
                                    <span style={{
                                        width: 12,
                                        height: 12,
                                        borderRadius: "50%",
                                        display: "inline-block",
                                        background: ev.destaque ? "#46B36F" : "#D6D6D6"
                                    }} />
                                </Box>
                                <Box>
                                    <Typography variant="body2" sx={{ fontWeight: 500, color: "#525252" }}>
                                        {ev.data}
                                    </Typography>
                                    <Typography variant="body2" sx={{ fontWeight: "bold", color: "#222", mb: 0.5 }}>
                                        {ev.titulo}
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: "#333", mb: 0.5 }}>
                                        {ev.descricao}
                                    </Typography>
                                </Box>
                            </Box>
                        )) : (
                            <Typography sx={{ color: "#888", textAlign: "center", py: 2 }}>
                                Nenhum evento registrado.
                            </Typography>
                        )}
                    </Box>
                </Paper>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2, justifyContent: "flex-end" }}>
                <Button onClick={onClose} color="success" variant="text" sx={{ fontWeight: "bold" }}>
                    FECHAR
                </Button>
            </DialogActions>
        </Dialog>
    );
}

interface HistoricoProdutoProps {
    open: boolean;
    onClose: () => void;
    numeroOC: string;
    produto: string;
    valorTotal: number;
    entregue: number;
    quantidade: number;
    eventos: HistoricoEvento[];
}
